import * as React from 'react';
import { CustomSubmitButton } from 'soprasteria-ui-library';
import { useAuth } from '../../../../App';
import { IOrthodonticReferralUploadFileAsConsultantModel } from '../../../../models/IOrthodonticReferral';
import { OrthodonticReferralAdministrationApi } from '../../../../api/OrthodonticReferralAdministrationApi';

interface IOrthodonticReferralSaveButton {
    orthodonticReferralId?: number;
    changeSuccessMessage: (message: string) => void;
    changeErrorMessage: (message: string) => void;
    getOrthodonticReferral: (id: number, refresh: boolean) => void;
}

export const OrthodonticReferralUploadFilesConsultantButton: React.FunctionComponent<IOrthodonticReferralSaveButton> = ({ changeErrorMessage, changeSuccessMessage, orthodonticReferralId, getOrthodonticReferral }) => {

    const auth = useAuth();
    const administrationApi = new OrthodonticReferralAdministrationApi(auth);
    const [isOrthodonticReferralSaving, setIsOrthodonticReferralSaving] = React.useState<boolean>(false);
    const saveButtonId = "upload-files-orthodontic-referral-button";

    const saveOrthodonticReferralForm = (data: IOrthodonticReferralUploadFileAsConsultantModel) => {
        setIsOrthodonticReferralSaving(true);
        administrationApi.uploadFilesAsConsultan(data, () => {
            if (orthodonticReferralId) {
                getOrthodonticReferral(orthodonticReferralId, true);
            }
            changeSuccessMessage("Ortodontiremissen har sparats");
        }, (error) => {
            changeErrorMessage(error);
        }, () => {
            setIsOrthodonticReferralSaving(false);
        });
    }

    return (
        <>
            <CustomSubmitButton onButtonSubmit={saveOrthodonticReferralForm} isLoading={isOrthodonticReferralSaving} id={saveButtonId}>Ladda upp filer</CustomSubmitButton>
        </>
    )
}